import React, { Component } from 'react';
import { connect } from 'react-redux';
import IgniteDataTable from '../../common/datatable';
import { history } from '../../../store';
import { destandard, ucfirst } from '../../../utils/commonFunctions';

class StaffMemberList extends Component {
  outletColumns = [
    {
      prop: 'id', title: 'ID', width: '100', onClick: (cell, row) => {
        history.push(`/admin/users/${row.id}/details`);
      }
    },
    { prop: 'name', title: 'Name' },
    { prop: 'status', title: 'Status' },
    {
      prop: 'user_group', title: 'User Group', format(data, row) {
        return (<b>{data.name || (ucfirst(data.toString()))}</b>)
      }
    },
    { prop: 'registration_date', title: 'Registration Date' },
  ];

  render() {
    let { owner, staffMembers } = this.props;

    if (owner) {
      staffMembers.push(destandard(owner));
    }

    return (
      <div>
        <IgniteDataTable
          hasAttributes={false}
          data={staffMembers}
          columns={this.outletColumns}
        />
      </div>
    );
  }
}

export default connect()(StaffMemberList);



// WEBPACK FOOTER //
// ./src/components/admin/outlet-view/staff-member-list.jsx